import { ref, Ref } from 'vue'
import { cloneDeep } from 'lodash-unified'
import { useStore } from '@gx-vuex'
import { isNumber } from '@/utils/validate'
import VideoEnPlayer from '@/utils/Player/Player'
import useScroll from './useScroll'
import { isMobileDevice } from '@/utils/util'
import { isBuild, typeViteEnv } from '@/utils/env'

const publicImageUrl = isBuild() ? typeViteEnv('VITE_OSS_BUILD_URL') + 'resource/image' : '/resource/image'

export type VideoItem = {
  id?: string;
  index?: number;
  url?: string;
  domId?: string;
  poster?: string;
  originId?: string;
  topFixed?: boolean;
  rect?: {
    top: number;
    width: number;
    height: number;
  };
  el?: HTMLElement
  elPatent?: HTMLElement
  dp?: Aliplayer
  player?: VideoEnPlayer
}

export default function (type: 'mobile' | 'pc', audioPlayNum: Ref<number>) {
  const store = useStore()
  const { directions, start: startScroll } = useScroll()

  const videoFixed = ref(false)

  const videoPreview = ref([])
  const defaultVideoPreview = ref<VideoItem[]>([])

  const videoState = reactive({
    currentVideo: {} as VideoItem
  })

  const haeVideo = computed(() => Object.keys(videoState.currentVideo).length > 0)

  const addVideoList = (option) => {
    videoPreview.value.push(option.id)
    defaultVideoPreview.value.push({
      id: option.id,
      url: option.src,
      poster: option.poster,
      originId: option.originId,
      rect: {
        top: 0,
        width: 0,
        height: 0
      },
      el: null,
      elPatent: null,
      dp: null,
      player: null
    })
  }

  const findVideo = (id) => {
    return defaultVideoPreview.value.find(el => el.id === id)
  }

  const removeVideoModal = () => {
    if (haeVideo.value && videoState.currentVideo.player && videoFixed.value) {
      videoFixed.value = false

      videoState.currentVideo.dp.pause()
      videoState.currentVideo.player.events.layerDom.toggleFixedLayer(false)

      videoPreview.value = []

      videoState.currentVideo = {}
    }
  }

  const closeVideoModal = (type?: 'close') => {
    if (haeVideo.value && videoState.currentVideo.player && videoFixed.value) {
      videoFixed.value = false
      videoState.currentVideo.dp.pause()
      videoState.currentVideo.player.events.layerDom.toggleFixedLayer(false)
      videoState.currentVideo.player.events.layerDom.toggleCommonLayer(
        videoState.currentVideo.player.template.$miniClose,
        false
      )
      videoState.currentVideo.player.events.layerDom.toggleCommonLayer(
        videoState.currentVideo.player.template.$miniLayer,
        false
      )

      if (
        (videoState.currentVideo.player.template.$video.currentTime >= videoState.currentVideo.player.template.$video.duration)
        && videoState.currentVideo.player.template.$video.currentTime > 0
      ) {
        videoState.currentVideo.player.events.clearSetTimeOut()
        videoState.currentVideo.player.events.playerEnd = true
        videoState.currentVideo.player.events.layerDom.toggleBottomPlayState(false)
        if (videoState.currentVideo.dp.fullscreenService.getIsFullScreen() as any) {
          videoState.currentVideo.dp.fullscreenService.cancelFullScreen()
          videoState.currentVideo.player.template.$bottomFullScreen.setAttribute(
            'src',
            publicImageUrl + '/player/fullScreen.svg'
          )
        }
        videoState.currentVideo.player.events.layerDom.toggleCommonLayer(
          videoState.currentVideo.player.template.$replay,
          true
        )
        videoState.currentVideo.player.events.layerDom.tooglePlayerBottom(false)
      } else {
        if (videoState.currentVideo.dp.getStatus() !== 'playing') {
          videoState.currentVideo.player.events.layerDom.toggleLayerPause(true)
        } else if (videoState.currentVideo.dp.getStatus() === 'playing') {
          const currentVideo = cloneDeep(videoState.currentVideo)
          setTimeout(() => {
            if (type === 'close') {

            } else {
              currentVideo.player.events.layerDom.toggleBottomPlayState(true)
              currentVideo.dp.play()
            }

          }, 100)
        }
      }

      videoPreview.value = defaultVideoPreview.value.filter((item) => {
        return (item.elPatent.getBoundingClientRect().top + item.rect.height) > 0
      }).map(item => item.id)

      videoState.currentVideo = {}
    }
  }

  watch(audioPlayNum, (val) => {
    if (val) {
      closeVideoModal('close')

      defaultVideoPreview.value.forEach(item => {
        if (item.dp) {
          item.dp.pause()
          item.player.events.layerDom.tooglePlayerBottom(false)
          item.player.events.layerDom.toggleLayerPause(true)
          item.player.events.layerDom.toggleBottomPlayState(false)

          setTimeout(() => {
            item.player.events.layerDom.tooglePlayerBottom(false)
            item.player.events.layerDom.toggleLayerPause(true)
            item.player.events.layerDom.toggleBottomPlayState(false)
          }, 100)
        }
      })
    }
  }, { deep: true })

  const handleScroll = (e) => {
    const eventTarget = e.target === document ? e.target.documentElement : e.target
    const scrollTop = eventTarget.scrollTop
    const headerHeight = document.getElementById('header').getBoundingClientRect().height
    if (type === 'pc') return
    if (!defaultVideoPreview.value.length) return
    if (directions.bottom) {
      if (!videoFixed.value && !haeVideo.value) {
        const hiddenVdeoId = videoPreview.value.find((item) => {
          const record = findVideo(item)
          return (Math.abs(record.elPatent.getBoundingClientRect().top) - record.rect.height + headerHeight) >= 0 &&
            record.elPatent.getBoundingClientRect().top < 0 &&
            record.dp.getStatus() === 'playing'
        })
        if (hiddenVdeoId) {
          videoState.currentVideo = {}
          videoState.currentVideo = findVideo(hiddenVdeoId)
        }
      }
      if (haeVideo.value && !videoFixed.value) {
        if (videoState.currentVideo.dp.getStatus() === 'playing') {   // 只有播放状态滚动过时才展示固定小窗
          videoFixed.value = true
          videoState.currentVideo.player.events.layerDom.toggleFixedLayer(true)
        } else {
          closeVideoModal()
        }
      } else {
        const hiddenVdeoId = defaultVideoPreview.value.find((item) => {
          const viewPortHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
          const offsetTop = item.elPatent.offsetTop
          return (offsetTop - scrollTop) < (viewPortHeight) && videoState.currentVideo.id === item.id
        })
        if (hiddenVdeoId && videoState.currentVideo.topFixed) {
          closeVideoModal()
        }
      }
    } else {
      if (videoFixed.value) {
        const currentVideos = defaultVideoPreview.value.find((item) => {
          return (item.elPatent.getBoundingClientRect().top + item.rect.height - headerHeight) > 0 && videoState.currentVideo.id === item.id
        })

        if (currentVideos) {
          const viewPortHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
          const offsetTop = currentVideos.elPatent.offsetTop
          if ((offsetTop - scrollTop) > (viewPortHeight - headerHeight)) {

          } else {
            closeVideoModal()
          }
        }
      } else {
        const currentVideos = defaultVideoPreview.value.find((item) => {
          return (item.elPatent.getBoundingClientRect().top + item.rect.height - headerHeight) > 0
        })

        if (currentVideos) {
          videoPreview.value = defaultVideoPreview.value.filter((item) => {
            return (item.elPatent.getBoundingClientRect().top + item.rect.height - headerHeight) > 0
          }).map(item => item.id)

          const needFixVideo = defaultVideoPreview.value.find((item) => {
            const viewPortHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
            const offsetTop = item.elPatent.offsetTop
            return (offsetTop - scrollTop) > (viewPortHeight) && item.dp && item.dp.getStatus() === 'playing'
          })

          if (needFixVideo) {
            const currentVideo = findVideo(needFixVideo.id)
            videoState.currentVideo = cloneDeep(findVideo(needFixVideo.id))

            if (videoState.currentVideo.dp) {
              videoState.currentVideo.dp = currentVideo.dp
              videoState.currentVideo.player = currentVideo.player
              videoFixed.value = true
              videoState.currentVideo.topFixed = true
              videoState.currentVideo.player.events.layerDom.toggleFixedLayer(true)
            }
          }
        }
      }
    }
  }

  const initVideo = async () => {
    startScroll(handleScroll)
    const videoList = document.querySelectorAll('#newContent .video-player')
    if (videoList.length) {
      for (let i = 0; i < videoList.length; i++) {
        const videoItem: any = videoList[i]
        const width = videoItem.getBoundingClientRect().width
        const domId = videoItem.getAttribute('id')
        const id = videoItem.getAttribute('data-id')
        const originWidth = videoItem.getAttribute('data-width') || 0
        const originHeight = videoItem.getAttribute('data-height') || 0
        const record: any = defaultVideoPreview.value.find(el => el.id === id)

        let height = isNumber(Number(originWidth)) ? isNaN(Number(originWidth)) || Number(originWidth) === 0
          ? 0
          : Number(width) * Number(originHeight) / Number(originWidth) : 0

        // if (type === 'pc') height = 495

        const isGiveWidth = !!height

        if (!height) height = isMobileDevice() ? Number(width) / (4 / 3) : 495

        videoItem.setAttribute('data-height', `${height}px`)
        videoItem.style.height = `${height}px`
        videoItem.parentNode.style.width = `100%`
        videoItem.parentNode.style.height = `${height}px`

        const player = new VideoEnPlayer({
          config: {
            key: i,
            record,
            isGiveWidth,
            width,
            height
          },
          callBackFun: {
            ready: (playerWdith, playerHieght, callBack) => {
              if (isGiveWidth || type === 'pc') return
              const newHeight = !!playerWdith && !!playerHieght
                ? Number(width) * Number(playerHieght) / Number(playerWdith)
                : isMobileDevice() ? Number(width) / (4 / 3) : 495
              videoItem.setAttribute('data-height', `${newHeight}px`)
              videoItem.style.height = `${newHeight}px`
              videoItem.parentNode.style.width = `100%`
              videoItem.parentNode.style.height = `${newHeight}px`
              callBack(newHeight)
            },
            play: () => {
              const _editor36 = document.querySelectorAll('.preview-audio-player')
              const coverAudioList = document.querySelectorAll('.preview-audio-player-cover')
              _editor36.forEach((item, _) => {
                const audioStylePlay: HTMLElement | null = item.querySelector('.audio-play-icon')
                const audioStylePause: HTMLElement | null = item.querySelector('.audio-pause-icon')

                const item_audio: HTMLAudioElement | null = item.querySelector('[class^="audio-block"]')
                if (item_audio) {
                  item_audio.pause()
                  if (audioStylePause) audioStylePause.style.display = 'none'
                  if (audioStylePlay) audioStylePlay.style.display = 'block'
                }
              })
              coverAudioList.forEach((item, _) => {
                const audioStylePlay: HTMLElement | null = item.querySelector('.audio-play-icon')
                const audioStylePause: HTMLElement | null = item.querySelector('.audio-pause-icon')

                const item_audio: HTMLAudioElement | null = item.querySelector('[class^="audio-block"]')
                if (item_audio) {
                  item_audio.pause()
                  if (audioStylePause) audioStylePause.style.display = 'none'
                  if (audioStylePlay) audioStylePlay.style.display = 'block'
                }
              })
            },
            pointError: () => {
              store.point.videoError('video url error')
            },
            closeFixModal: (id) => {
              if (id) {
                const dp = defaultVideoPreview.value.find(item => item.id === id)?.dp

                if (dp) {
                  dp?.pause()
                }
              }
              closeVideoModal(id ? 'close' : null)
            },
            pauseOhterDp: (currentId) => {
              defaultVideoPreview.value = defaultVideoPreview.value.map((item) => {
                if (item.id !== currentId) {
                  item.dp.pause()
                  item.player.events.layerDom.toggleLayerPause(true)
                  item.player.events.layerDom.tooglePlayerBottom(false)
                }
                return item
              })
            },
            continueNetwork: () => {},
            videoEnd: () => {
              // try {
              //   sensors.track('video_end_pybk', {
              //     duration: duration,
              //     complet_rate: current > 0
              //       ? duration === current ? 1 : 0
              //       : 0,
              //     ...pointCommont({ recommondType: 'stay', currentTime: current })
              //   })
              // } catch (e) {
              //   console.log(e)
              // }
            },
            fullScreen: () => {
              // try {
              //   sensors.track('NameClick', {
              //     click_name: 'full_screen_click',
              //     ...pointBasic
              //   })
              // } catch (e) {}
            },
            fristPlay: () => {
              // try {
              //   sensors.track('video_positive_pybk', {
              //     time_consuming: duration,
              //     ...pointCommont({ recommondType: 'click' })
              //   })
              // } catch (e) {
              //   console.log(e)
              // }
            }
          }
        })

        defaultVideoPreview.value = defaultVideoPreview.value.map(item => {
          if (item.id === id) {
            item.index = i
            item.rect.width = width
            item.rect.height = height
            item.el = videoItem
            item.elPatent = videoItem.parentNode
            item.dp = player.player
            item.player = player
            item.domId = domId
          }
          return item
        })
      }
    }
  }

  const removeDpVideo = () => {
    defaultVideoPreview.value = defaultVideoPreview.value.map((el) => {
      if (el.player) el.player.destroy()
      el.dp = null
      el.player = null
      return el
    })

    removeVideoModal()

    videoState.currentVideo = {}
    videoPreview.value = []
    defaultVideoPreview.value = []
  }

  return {
    initVideo,
    addVideoList,
    removeDpVideo
  }
}
